'use client'

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider as MThemeProvider } from '@mui/material/styles'
import { FC, ReactNode } from 'react'
import makeTheme from './theme'
import { InterNationsThemeOptions } from './theme/types'

export type UIThemeOptions = InterNationsThemeOptions

type Props = {
    children: ReactNode
    themeOptions?: InterNationsThemeOptions
}

const cssBaseline = <CssBaseline />

const ThemeProvider: FC<Props> = ({ children, themeOptions = {} }: Props) => (
    <MThemeProvider theme={makeTheme(themeOptions)}>
        {cssBaseline}
        {children}
    </MThemeProvider>
)

export default ThemeProvider
